export default __webpack_public_path__ + "static/media/eb-ultra-wht-banner-1.a4617179.jpg";